import { useState, useEffect } from 'react';
import api from '../services/api.js';

// LEGAL-PAGE-AND-PROVISION-TEMPLATES-1 Part 3 — tenant capability signal.
// GET /api/capabilities reports which requireTenantTable-gated tables exist on
// this tenant's DB. Module-level cache: one fetch per SPA load, shared by the
// sidebar and every gated page.
//
// Return shape: null while loading (callers render nothing / keep nav hidden),
// then { tables: { EdiTransactions: bool, RawMaterialLinks: bool,
// RochHistoricalSales: bool, RfqRequests: bool } }. On fetch failure resolves to
// { tables: {} } — all gated features stay hidden rather than flashing a page
// the backend will 404.

let _caps = null;
let _promise = null;
const _subs = new Set();

function fetchCaps() {
  if (!_promise) {
    _promise = api.get('/api/capabilities')
      .then(r => { _caps = r.data ?? { tables: {} }; })
      .catch(() => { _caps = { tables: {} }; })
      .then(() => { _subs.forEach(fn => fn(_caps)); });
  }
  return _promise;
}

export function useCapabilities() {
  const [caps, setCaps] = useState(_caps);
  useEffect(() => {
    if (_caps) { setCaps(_caps); return undefined; }
    _subs.add(setCaps);
    fetchCaps();
    return () => { _subs.delete(setCaps); };
  }, []);
  return caps;
}

export function hasCapability(caps, table) {
  return !!caps?.tables?.[table];
}
